<template>
    <card class="form-horizontal">
        <div class="card-header">
            <h6 class="card-title text-center">
                Datos personales
            </h6>
        </div>
        <div class="card-body">
            <div class="form-group">
                <label>Primer nombre *</label>
                <fg-input   tabindex="1"
                            type="text"
                            name="nombre de cliente"
                            autocomplete="off"
                            v-validate="modelValidations.customerFirstName"
                            :error="getError('nombre de cliente')"
                            v-model="customerFirstName">
                </fg-input>
            </div>
            <div class="form-group">
                <label>Segundo nombre</label>
                <fg-input   tabindex="2"
                            type="text"
                            name="segundo nombre de cliente"
                            autocomplete="off"
                            v-validate="modelValidations.customerSecondName"
                            :error="getError('segundo nombre de cliente')"
                            v-model="customerSecondName">
                </fg-input>
            </div>
            <div class="form-group">
                <label>Primer apellido *</label>
                <fg-input   tabindex="3"
                            type="text"
                            name="apellido de cliente"
                            autocomplete="off"
                            v-validate="modelValidations.customerSurname"
                            :error="getError('apellido de cliente')"
                            v-model="customerSurname">
                </fg-input>
            </div>
            <div class="form-group">
                <label>Segundo apellido</label>
                <fg-input   tabindex="4"
                            type="text"
                            name="segundo apellido de cliente"
                            autocomplete="off"
                            v-validate="modelValidations.customerSecondSurname"
                            :error="getError('segundo apellido de cliente')"
                            v-model="customerSecondSurname">
                </fg-input>
            </div>
            <div class="form-group">
                <label>Tipo de identificación *</label>
                <fg-input   tabindex="5"
                            name="tipo de identificación"
                            v-validate="modelValidations.customerIdentificationType"
                            :error="getError('tipo de identificación')"
                            v-model="customerIdentificationType">
                        <el-select
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="customerIdentificationType">
                        <el-option v-for="identificationDocumentType in $store.getters.getIdentificationDocumentTypes" :key="identificationDocumentType.id"
                                class="select-warning"
                                :value="identificationDocumentType.id"
                                :label="identificationDocumentType.name">
                        </el-option>
                    </el-select>
                </fg-input>
            </div>
            <div class="form-group">
                <label>Número de identificación *</label>
                <fg-input   tabindex="6"
                            type="number"
                            name="número de identificación"
                            autocomplete="off"
                            v-validate="modelValidations.customerIdentificationNumber"
                            :error="getError('número de identificación')"
                            v-model="customerIdentificationNumber">
                </fg-input>
            </div>
            <!-- <div class="form-group">
                <label>Edad</label>
                <fg-input   tabindex="7"
                            type="number"
                            name="edad"
                            autocomplete="off"
                            v-validate="modelValidations.customerAge"
                            :error="getError('edad')"
                            v-model="customerAge">
                </fg-input>
            </div> -->
        </div>
        <div class="card-footer">
            <div class="text-right">
                <p-button @click="toRequestData()" type="warning">Siguiente</p-button>
                <p-button @click="toDashboard()" type="default" class="pull-left mb-3">Cancelar</p-button>
            </div>
        </div>
    </card>
</template>
    <script>
    import { Card } from 'src/components/UIComponents'
    import Vue from 'vue'
    import {Select, Option} from 'element-ui'
    import moment from 'moment'
    import { isEmpty } from 'lodash';
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card
        },
        data() {
        return {
            modelValidations: {
                customerFirstName: {
                    required: true,
                    max: 16
                },
                customerSecondName: {
                    required: false,
                    max: 16
                },
                customerSurname: {
                    required: true,
                    max: 16
                },
                customerSecondSurname: {
                    required: false,
                    max: 16
                },
                customerIdentificationNumber: {
                    required: true,
                    numeric: true,
                    max_value: 999999999999
                },
                // customerAge: {
                //     required: true,
                //     numeric: true,
                //     between: [18,99]
                // },
                customerIdentificationType: {
                    required: true,
                },
            },
        }
        },
        computed: {
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            customerFirstName: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerFirstName;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerFirstName;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerFirstName', val)
                }
            },
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            customerSecondName: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSecondName;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSecondName;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerSecondName;
                    }

                },
                set: function (val) {
                    this.$store.commit('updateCustomerSecondName', val)
                }
            },
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            customerSurname: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSurname;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSurname;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerSurname;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerSurname', val)
                }
            },
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            customerSecondSurname: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSecondSurname;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSecondSurname;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerSecondSurname;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerSecondSurname', val)
                }
            },
            /**
             * Función para almacenar en vuex el número de identificación del cliente
             */
            customerIdentificationNumber: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerIdentificationNumber;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationNumber;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerIdentificationNumber;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerIdentificationNumber', val)
                }
            },
            /**
             * Función para almacenar en vuex el número la edad cliente
             */
             customerAge: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerAge;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerAge;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerAge;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerAge', val)
                }
            },
            /**
             * Función para almacenar en vuex el tipo de identificación del cliente
             */
            customerIdentificationType: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerIdentificationType;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationType;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerIdentificationType;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerIdentificationType', val)
                }
            }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toDashboard () {
                this.$router.push('/admin/overview');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        var payload = {
                            stage: 'Ingreso de datos de cliente',
                            description: 'Se ingresan los datos del titular.',
                            dateTime: moment().format()
                        };
                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                            this.$router.push('/asessments/new_asessment/customer/request_data');
                        });
                    }
                })
            }
        },
        mounted() {
            if(this.$store.state.isSpouse) {
                if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100 !== 'undefined' && !_.isEmpty(this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100)) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0].customer.spouse.spouse_identification_number != null || this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0].customer.spouse.spouse_identification_number != '') {
                        this.customerFirstName = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0].customer.spouse.spouse_first_name;
                        this.customerSecondName = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0].customer.spouse.spouse_second_first_name;
                        this.customerSurname = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0].customer.spouse.spouse_last_name;
                        this.customerSecondSurname = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0].customer.spouse.spouse_second_last_name;
                        this.customerIdentificationNumber = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0].customer.spouse.spouse_identification_number;
                        this.customerIdentificationType = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0].customer.spouse.spouse_identification_type;
                    }
                }
            }
        }
    }
</script>
<style>
</style>
